/* 商品詳細：写真スライダー・カートに入れる・おすすめの読み込み */
(() => {
  const root = document.querySelector('[data-product-section]');
  if (!root) return;

  // ---------- 写真スライダー ----------
  const slides = root.querySelector('.js-slides');
  const bars = root.querySelector('.js-bars');
  const thumbs = root.querySelector('.js-thumbs');
  const count = slides ? slides.children.length : 0;
  let cur = 0;
  const mark = () => {
    if (bars) [...bars.children].forEach((b, i) => b.classList.toggle('is-on', i === cur));
    if (thumbs) thumbs.querySelectorAll('button').forEach((b, i) => {
      b.classList.toggle('is-on', i === cur);
      if (i === cur) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  };
  const go = i => {
    if (!count) return;
    cur = (i + count) % count;
    slides.scrollTo({ left: slides.clientWidth * cur, behavior: 'smooth' });
    mark();
  };
  if (slides && count > 1) {
    slides.addEventListener('scroll', () => {
      const i = Math.round(slides.scrollLeft / slides.clientWidth);
      if (i !== cur) { cur = i; mark(); }
    }, { passive: true });
    root.querySelector('.js-prev')?.addEventListener('click', () => go(cur - 1));
    root.querySelector('.js-next')?.addEventListener('click', () => go(cur + 1));
    [bars, thumbs].forEach(el => el?.addEventListener('click', e => {
      const b = e.target.closest('[data-i]');
      if (b) go(+b.dataset.i);
    }));
    slides.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') go(cur - 1);
      if (e.key === 'ArrowRight') go(cur + 1);
    });
    mark();
  }

  // ---------- カートに入れる（画面を移動せずに追加） ----------
  const form = root.querySelector('.js-product-form');
  const toast = document.querySelector('.js-toast');
  const msg = root.querySelector('.js-form-msg');
  const showToast = text => {
    if (!toast) return;
    toast.querySelector('.js-toast-text').textContent = text;
    toast.classList.add('is-show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-show'), 5000);
  };
  if (form && window.fetch) {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const label = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = form.dataset.adding || '…';
      if (msg) msg.hidden = true;
      try {
        const res = await fetch(window.Shopify?.routes?.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'error');
        showToast(form.dataset.added || '');
        const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then(r => r.json());
        document.querySelectorAll('.js-cart-count').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      } catch (err) {
        if (msg) { msg.textContent = err.message && err.message !== 'error' ? err.message : (form.dataset.error || ''); msg.hidden = false; }
      } finally {
        btn.disabled = false;
        btn.innerHTML = label;
      }
    });
  }

  // ---------- おすすめの時計 ----------
  const rec = document.querySelector('.js-recommendations');
  if (rec && rec.dataset.url && !rec.querySelector('.product-grid')) {
    fetch(rec.dataset.url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.js-recommendations');
      if (fresh && fresh.querySelector('.product')) {
        rec.innerHTML = fresh.innerHTML;
        rec.hidden = false;
        rec.querySelectorAll('.reveal').forEach(el => el.classList.add('is-in'));
      } else {
        rec.hidden = false;
      }
    }).catch(() => { rec.hidden = false; });
  }
})();
